import { Snackbar } from "@octopusdeploy/design-system-components";
import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { useState } from "react";
import { ScopedCommonTemplatesInlineTabContent } from "~/areas/projects/components/Variables/TenantVariables/ScopedTenantVariables/ScopedCommonTemplatesInlineTabContent";
import type { ScopedCommonTemplatesState } from "~/areas/projects/components/Variables/TenantVariables/ScopedTenantVariables/useScopedCommonTemplatesState";
import type { TenantVariableFiltersData } from "~/areas/projects/components/Variables/TenantVariables/useTenantVariableFiltersData";
import type { TenantVariableResourceOptions } from "~/areas/projects/components/Variables/TenantVariables/useTenantVariableResourceOptions";
import type { DoBusyTask } from "~/components/DataBaseComponent/index";
import type { CommonTemplatesChangeTracker } from "../useCommonTemplatesChangeTracker";
interface ScopedCommonTemplatesInlineContentProps {
    project: ProjectResource;
    doBusyTask: DoBusyTask;
    contentState: ScopedCommonTemplatesState;
    filterData: TenantVariableFiltersData;
    variableResourceOptions: TenantVariableResourceOptions;
    changeTracker: CommonTemplatesChangeTracker;
}
export default function ScopedCommonTemplatesInlineContent({ project, doBusyTask, contentState, filterData, variableResourceOptions, changeTracker }: ScopedCommonTemplatesInlineContentProps) {
    const { data, connectedEnvironments, pageSize, filterState, actions } = contentState;
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
    const [snackbarText, setSnackbarText] = useState("");
    const onIncludeVariableSetFromOnboarding = (text: string) => {
        setIsSnackbarOpen(true);
        setSnackbarText(text);
    };
    return (<>
            {data && (<ScopedCommonTemplatesInlineTabContent project={project} connectedEnvironments={connectedEnvironments} doBusyTask={doBusyTask} filterState={filterState} filterData={filterData} setFilterState={actions.setFilter} pageSize={pageSize} setPageState={actions.setPageState} commonTemplatesWithValues={data} onAddTemplateFromOnboarding={onIncludeVariableSetFromOnboarding} resourceOptions={variableResourceOptions} changeTracker={changeTracker}/>)}
            <Snackbar open={isSnackbarOpen} content={snackbarText} autoHideDuration={3500} onClose={() => setIsSnackbarOpen(false)} textAlign={"center"}/>
        </>);
}
